export default __webpack_public_path__ + "static/media/hands.4064a16c.png";